import type { Monaco } from "@monaco-editor/react";
import type { MonacoEditor } from "../ChatInput.types";
import {
  disableMonacoCommands,
  setupEditorKeyboardHandlers,
} from "./monacoSetup.utils";

export function setupMonacoKeyboard(
  editor: MonacoEditor,
  monaco: Monaco,
  onSubmit: () => void,
  onCancel: (() => void) | undefined,
  updateHeight: () => void
) {
  // Disable Monaco shortcuts
  disableMonacoCommands(editor, monaco);

  // Setup custom keyboard handlers
  setupEditorKeyboardHandlers(editor, monaco, { onSubmit, onCancel, updateHeight });
}
